import { useEffect, useState } from 'react';

/** `mail.css`'s fold to one column. */
export const PHONE_QUERY = 'not all and (min-width: 860px)';

/** Whether the window is narrow enough that `mail.css` has folded to one
 *  column. `false` where `matchMedia` does not exist. */
export function usePhone(): boolean {
  const [phone, setPhone] = useState(false);
  useEffect(() => {
    const query = window.matchMedia?.(PHONE_QUERY);
    if (!query) return;
    const sync = () => setPhone(query.matches);
    sync();
    query.addEventListener('change', sync);
    return () => query.removeEventListener('change', sync);
  }, []);
  return phone;
}
